import React, { useEffect, useState, Children, createElement } from 'react';
import { Header } from '../components/Header';
import { VideoPlayer } from '../components/VideoPlayer';
import { HeroHighlight, Highlight } from '../components/ui/HeroHighlight';
import { BookCallButton } from '../components/ui/BookCallButton';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
const vttContent = `WEBVTT

00:00:00.000 --> 00:00:04.500
All right, the next step of the process here is that we need your help

00:00:04.500 --> 00:00:09.000
in answering some questions about your company and about the role itself,

00:00:09.000 --> 00:00:13.000
compensation, and a few other things. There's going to be a link below

00:00:13.000 --> 00:00:17.500
that once you click it, it will take you to a form to fill out those questions.

00:00:17.500 --> 00:00:22.000
The more details you can provide, the better it will be for us

00:00:22.000 --> 00:00:26.000
and the build of the campaign itself. These questions are going to help us

00:00:26.000 --> 00:00:30.000
frame the culture and opportunity video that we are going to record and shoot

00:00:30.000 --> 00:00:34.000
with our actors and our team to be able to present that to the applicants

00:00:34.000 --> 00:00:37.000
applying for this role. Again, the more detail that you can give us,

00:00:37.000 --> 00:00:40.000
the better. Click the link below and let's get started with this.`;
export function OnboardingPage() {
  const [vttUrl, setVttUrl] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
    // Load Typeform embed script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);
    const blob = new Blob([vttContent], {
      type: 'text/vtt'
    });
    const url = URL.createObjectURL(blob);
    setVttUrl(url);
    return () => {
      URL.revokeObjectURL(url);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  const navigate = useNavigate();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleNextStep = () => {
    setIsDialogOpen(true);
  };
  const handleConfirm = () => {
    setIsDialogOpen(false);
    navigate('/dns');
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        when: 'beforeChildren',
        staggerChildren: 0.1,
        duration: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      y: 20,
      opacity: 0
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        damping: 12,
        stiffness: 100,
        duration: 0.4
      }
    }
  };
  return <div className="w-full h-screen overflow-hidden" data-id="element-318">
      <HeroHighlight data-id="element-319">
        <div className="h-screen flex flex-col" data-id="element-320">
          <Header data-id="element-321" />
          <motion.main className="flex-1 flex flex-col justify-center max-w-5xl mx-auto px-4 w-full" initial="hidden" animate="visible" variants={containerVariants} data-id="element-322">
            <motion.div variants={itemVariants} data-id="element-323">
              <div className="flex justify-center mb-2 sm:mb-3 items-center" data-id="element-324">
                <div className="flex items-center" data-id="element-325">
                  <motion.button onClick={() => navigate('/culture-questions')} className="mr-2 h-7 w-7 sm:h-8 sm:w-8 flex items-center justify-center rounded-full bg-white/5 backdrop-blur-sm border border-white/10 text-white hover:bg-white/10 transition-colors" whileHover={{
                  scale: 1.05
                }} whileTap={{
                  scale: 0.95
                }} data-id="element-326">
                    <ChevronLeftIcon className="w-4 h-4" data-id="element-327" />
                  </motion.button>
                  <div className="inline-flex items-center px-3 sm:px-5 py-1 sm:py-1.5 rounded-full border border-white/30 bg-black/30 backdrop-blur-sm" data-id="element-328">
                    <span className="text-xs sm:text-sm font-medium text-white" data-id="element-329">
                      STEP
                    </span>
                    <div className="inline-flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mx-1 sm:mx-1.5 rounded-full bg-white" data-id="element-330">
                      <span className="text-xs sm:text-sm font-bold text-gray-900" data-id="element-331">
                        2
                      </span>
                    </div>
                    <span className="text-xs sm:text-sm font-medium text-white" data-id="element-332">
                      OF 4
                    </span>
                  </div>
                </div>
              </div>
              <h1 className="text-center text-lg sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 sm:mb-3 max-w-3xl mx-auto leading-[1.3] text-white" data-id="element-333">
                Questions for Culture and Opportunity Video
              </h1>

              <div className="relative max-w-3xl mx-auto w-full" data-id="element-334">
                <VideoPlayer mediaId="zw6yi665xl" data-id="element-335" />
                <motion.button onClick={handleNextStep} className="hidden md:flex flex-col items-center gap-1 px-3 py-4 rounded-xl bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors cursor-pointer absolute -right-16" style={{
                top: '50%',
                y: '-50%'
              }} whileHover={{
                scale: 1.05,
                x: 4
              }} whileTap={{
                scale: 0.95
              }} data-id="element-336">
                  <ChevronRightIcon className="w-6 h-6" data-id="element-337" />
                  <span className="text-xs font-semibold whitespace-nowrap" data-id="element-338">
                    Next
                  </span>
                </motion.button>
              </div>
              <motion.button onClick={handleNextStep} className="md:hidden flex items-center justify-center gap-2 mx-auto mt-3 py-2.5 px-6 rounded-xl bg-white/10 border border-white/20 text-white hover:bg-white/20 transition-colors cursor-pointer" whileTap={{
              scale: 0.95
            }} data-id="element-339">
                <span className="text-sm font-semibold" data-id="element-340">Next</span>
                <ChevronRightIcon className="w-5 h-5" data-id="element-341" />
              </motion.button>
            </motion.div>
            <motion.div className="mt-4 sm:mt-5" variants={itemVariants} data-id="element-342">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-2xl mx-auto" data-id="element-343">
                <div className="w-full sm:w-auto" data-id="element-344">
                  <p className="text-center text-sm font-semibold text-white mb-2" data-id="element-345">
                    Click the button below
                  </p>
                  <motion.button data-tf-popup="QoFlKBSe" onClick={() => {
                  if ((window as any).tf && (window as any).tf.createPopup) {
                    ;
                    (window as any).tf.createPopup('QoFlKBSe').open();
                  }
                }} className="w-full py-2.5 px-6 text-base sm:text-lg bg-[#7fe0c3] hover:bg-[#6dd4b3] text-white font-bold rounded-xl transition-all duration-300 shadow-xl" whileHover={{
                  scale: 1.05,
                  boxShadow: '0 10px 25px -5px rgba(127, 224, 195, 0.5)'
                }} whileTap={{
                  scale: 0.98
                }} data-id="element-346">
                    Answer Questions
                  </motion.button>
                </div>
              </div>
            </motion.div>
          </motion.main>
        </div>
      </HeroHighlight>
      <ConfirmationDialog isOpen={isDialogOpen} onClose={() => setIsDialogOpen(false)} onConfirm={handleConfirm} title="Did you fully complete this step?" message="You need to complete this step before proceeding to the next one." data-id="element-347" />
    </div>;
}